// extracted by mini-css-extract-plugin
export default {"backgroundSection":"BackgroundSection_backgroundSection__BOEpz","container":"BackgroundSection_container__VxQqz","titleHome":"BackgroundSection_titleHome__Cib5j"};